import Vue from '../setup'

export const HTTP = Vue.http
export const user = Vue.resource('/api/user{/id}')
export const userPwd = Vue.resource('/api/user/password')
export const userFavour = Vue.resource('/api/favour{?type}')
export const match = Vue.resource('/api/match{/id}{?leagueId,isRecommended,q,teamId,cityId,time,userId}')
export const matchDetail = Vue.resource('/api/matchDetail{/id}')
export const custom = Vue.resource('/api/custom{/id}{?categoryId, cityId, time, type}')
export const customFilterInfo = Vue.resource('/api/custom/filter{?categoryId, cityId, time}')
export const customOrder = Vue.resource('/api/custom/order{/customOrderId}')
export const league = Vue.resource('/api/league{?isOversea}')
export const filterInfo = Vue.resource('/api/league/filter{/id}')
export const introduction = Vue.resource('/api/match/introduction{/id}')
export const order = Vue.resource('/api/orders{/id}{?userId,type,listType}')
export const adv = Vue.resource('/api/ads')
export const route = Vue.resource('/api/route{/id}{?time,categoryId,cityId,isRecommended,userId}')
export const question = Vue.resource('/api/question{?tourRouteId,routeId,matchId,userId}')
export const config = Vue.resource('/api/config')
export const raiders = Vue.resource('/api/raiders{/id}')
export const attn = Vue.resource('/api/user/attn{/userId}')
export const commonAttn = Vue.resource('/api/user/commonAttn{/userId}')
export const address = Vue.resource('/api/user/address{/userId}')
export const realNameInfo = Vue.resource('/api/user/realName{/userId}')
export const worldCupMatch = Vue.resource('/api/worldCup{?type,group}')
export const tourDetail = Vue.resource('/api/tour/Detail{/id}{?userId}')
export const userMobile = Vue.resource('/api/user/modifyMobile{/id}')
export const sportsTourFilterInfo = Vue.resource('/api/sportsTour/filter{?categoryId, cityId, time}')
export const sportsTour = Vue.resource('/api/sportsTour{/id}{?categoryId, cityId, time, type}')
export const travelOrder = Vue.resource('/api/travelOrders{/id}{?userId}')
export const travelerOption = Vue.resource('/api/travelerOption{?userId,count,certificateType}')



// WEBPACK FOOTER //
// ./client/vuex/resource.js